<script>
import { Account } from './../../functions.js'

import AccountAPI from './../../api/account.js'

export default {
  name: 'Logout',
  data() {
    return {
       Account,
    }
  },
  mounted() {
    var token = this.Account.getToken();
    var logout_request = AccountAPI.logout(token)
    logout_request.then((response)=>{
      this.Account.setToken('');
      this.Account.setLoginId('');
      this.$router.push({ name: "login", query: { 'm' :"logout"}})
    });
  }
}
</script>
<template>
  <div class="page logout-page">
    Logging Out
  </div>
</template>



// WEBPACK FOOTER //
// src/components/page/Logout.vue